/**
 * Greedily matches loaded tasks to their best available appointments.
 * Pairs are scored and sorted; each appointment and task can only be claimed once.
 * Mutates tasks in place via task.linkAppointment().
 * @param {import('../entities/ReconciliationTask.types').ReconciliationTask[]} tasks
 * @param {import('../entities/ReconciliationSettings.types').ReconciliationSettings} settings
 */
// eslint-disable-next-line import/prefer-default-export
export function matchTasksToAppointments(tasks, settings) {
  const startTolerance = settings.startTimeToleranceMinutes * 60;
  const endTolerance = settings.endTimeToleranceMinutes * 60;

  const pairs = [];
  tasks.filter((t) => t.isLoaded())
    .forEach((task) => {
      task.availableAppointments.forEach((appt) => {
        const score = task.scoreAppointment(appt, startTolerance, endTolerance);
        if (score !== null) {
          pairs.push({ task, appt, score });
        }
      });
    });

  pairs.sort((a, b) => a.score - b.score);

  const claimedAppointmentIds = new Set();
  const matchedTasks = new Set();
  pairs.forEach(({ task, appt }) => {
    if (matchedTasks.has(task) || claimedAppointmentIds.has(appt.id)) {
      return;
    }
    task.linkAppointment(appt.id);
    claimedAppointmentIds.add(appt.id);
    matchedTasks.add(task);
  });
}
